import { Directive } from '@angular/core';
import { CalendarDay, CalendarFlorderInfo, CalendarFlorders } from 'app/core/store/calendar/common/calendar.interface';
import { FlordersFilter } from 'app/core/interfaces/florders-filter.interface';
import { Place } from 'app/core/interfaces/place.interface';
import { CDFlorderType, ContractRestrictions } from 'app/core/store/contract-details/contract-details.interface';
import { AvailablePickingDates, OrderDetail, RelocationDetail } from 'app/core/store/edit-florder-detail/florder-detail.interface';
import { BaseContainer } from 'app/modules/base/BaseContainer';

@Directive()
export abstract class CalendarPageContainer<CF extends CalendarFlorders<OrderDetail | RelocationDetail>> extends BaseContainer {
  restrictions: ContractRestrictions;
  orderTypes: CDFlorderType[];
  places: { [key: string]: Place };
  flordersState: CF;
  deliveryDaysRequesting: boolean = false;
  availableDays: AvailablePickingDates;
  selectedTemplate: OrderDetail | RelocationDetail;
  florder: OrderDetail;
  filter: FlordersFilter;

  private onOver(source: Element) {
    // simulate the hover effect on the day
    source.classList.add('focus');
  }

  private onOut(source: Element) {
    // remove the hover effect when hovering away from the day
    source.classList.remove('focus');
  }

  abstract requestDeliveryDates();

  abstract createFlorder();

  abstract createTemplate();

  abstract editTemplate(templateId: number);

  abstract deleteTemplate(templateId: number);

  protected abstract showFlorderModal<T extends CalendarDay>(day: T);

  protected abstract openFlorder(florder: CalendarFlorderInfo);

  protected abstract loadFlorders(filter: { fromDate: string; toDate: string });

  abstract createFlorderFromTemplate(templateId: number, date: string);
}
